let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gJZ3Q")).then(() => parcelRequire('3U2yH'));